module.exports = __webpack_public_path__ + "img/logo.9a2ff824.png";